{
    const selector = '.video-shariff-play';
  
    function onClick(e) {
      let t = e.target.closest(selector)
      if (!t) return;
    
        let p = t.parentElement;
        t.outerHTML = JSON.parse(t.dataset.video);
        // behavior Optional
        // Defines the transition animation. One of auto or smooth. Defaults to auto.
        
        // block Optional
        // Defines vertical alignment. One of start, center, end, or nearest. Defaults to start.
        
        // inline Optional
        // Defines horizontal alignment. One of start, center, end, or nearest. Defaults to nearest.        
        p.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center',
        });
    }
  
    document.addEventListener('click', onClick)
  }
  